import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {
  GroupDetailsContactModel,
  GroupDetailsModel,
  GroupDetailsVenueModel,
  GroupDetailsVenueSubsidiaryModel
} from './create-group.model';
import {GroupDatabaseService} from '../group-database/group-database.service';
import {CreateGroupService} from './create-group.service';
import {Toast, ToasterConfig, ToasterService} from 'angular2-toaster';
import {StatisticsGroupModel} from '../../shared/objects/statistics-group.model';
import {DxDataGridComponent} from "devextreme-angular";


@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.less'],
  providers: [CreateGroupService]
})
export class CreateGroupComponent implements OnInit {
  buttonsEnabled = true;
  switchVenue: boolean;
  switchVenueDestination: any;
  @Input() showGroup: boolean;
  @Input() selectedGroupId: number;
  @Output() showGroupChange = new EventEmitter<number>();

  @Output() showVenueChange = new EventEmitter<boolean>();
  @Output() switchVenueEvent = new EventEmitter<number>();
  @Output() newVenueEvent = new EventEmitter<number>();

  modelState: string;
  showCloseConfirmation = false;
  addUser = false;
  deleteGroup = false;
  deleteGroupLiveInfo = false;
  activeTab = 1;
  editNameActive = false;
  lengthOfVenues: number;
  selectedContactIndex: number;
  managerAdmin: boolean;

  groupDetailsModel: GroupDetailsModel;
  groupDetailsVenuesModel: GroupDetailsVenueModel[];
  groupDetailsSubsidiaryModel: GroupDetailsVenueSubsidiaryModel[];
  selectedContact = new GroupDetailsContactModel();

  statisticsGroupModel: StatisticsGroupModel[];
  onlyBars = false;
  onlyRestaurants = false;
  bothSubgroups = false;

  confirmEnabled = true;

  constructor(private groupDatabaseService: GroupDatabaseService,
              private createGroupService: CreateGroupService, private toasterService: ToasterService) {
  }

  ngOnInit() {

    this.managerAdmin = true;

    if (this.selectedGroupId) {
      this.createGroupService.getGroupAnalytisc(this.selectedGroupId)
        .subscribe(
          (response) => {
            this.statisticsGroupModel = response;
            for (const group of this.statisticsGroupModel) {
              if (group.name !== 'Demographic') {
                if (group.statisticsSubgroups.length === 2) {
                  this.bothSubgroups = true;
                  this.onlyRestaurants = false;
                  this.onlyBars = false;
                  break;
                } else {
                  for (const subGroup of group.statisticsSubgroups) {
                    if (subGroup.name === 'Restaurants') {
                      this.onlyRestaurants = true;
                      this.onlyBars = false;
                      this.bothSubgroups = false;
                    } else if (subGroup.name === 'Bars') {
                      this.onlyBars = true;
                      this.onlyRestaurants = false;
                      this.bothSubgroups = false;
                    }
                  }
                }
              }
            }
          },
          (error) => console.log(error)
        );

      this.groupDatabaseService.getGroupDetails(this.selectedGroupId)
        .subscribe(
          (response: GroupDetailsModel) => {
            console.log(response);
            this.groupDetailsModel = response;
            this.groupDetailsVenuesModel = this.groupDetailsModel.venues;
            this.saveState();
            console.log(this.groupDetailsModel);
          },
          (error) => console.log(error)
        );
    } else {
      this.groupDetailsModel = new GroupDetailsModel();
    }
  }

  closeX() {
    if (this.buttonsEnabled) {
      this.close();
    }
  }

  close() {
    if (this.stateChanged()) {
      this.showCloseConfirmation = true;
    } else {
      this.closeConfirmed();
    }
  }

  closeConfirmed() {
    this.showGroupChange.emit(0);
  }

  addOrEdit(index?) {
    if (index != null) {
      this.selectedContact = <GroupDetailsContactModel> JSON.parse(JSON.stringify(this.groupDetailsModel.contacts[index]));
      this.selectedContactIndex = index;
    } else {
      this.selectedContact = new GroupDetailsContactModel();
      this.selectedContactIndex = -1;
    }
    this.addUser = true;
  }

  deleteContact(index) {
    this.selectedContactIndex = index;
    this.groupDetailsModel.contacts.splice(index, 1);
  }

  closePopUp() {
    this.addUser = false;
    this.deleteGroup = false;
    this.switchVenue = false;
    this.showCloseConfirmation = false;
    this.deleteGroupLiveInfo = false;
  }

  changeTab(selected) {
    this.activeTab = selected;
  }

  addContactGroup(valid) {
    if (valid) {
      if (this.selectedContactIndex > -1) {
        this.groupDetailsModel.contacts[this.selectedContactIndex] = this.selectedContact;
      } else {
        this.groupDetailsModel.contacts.push(this.selectedContact);
      }
      this.addUser = false;
    }
    return false;
  }

  delete() {
    this.deleteGroup = true;
  }

  save(goToVenue) {
    const component = this;
    this.confirmEnabled = false;
    this.buttonsEnabled = false;
    if (this.groupDetailsModel.id && this.groupDetailsModel.id !== 0) {
      this.createGroupService.updateGroup(this.groupDetailsModel).subscribe((response) => {
          this.buttonsEnabled = true;

          if (goToVenue) {
            this.venueSwitchConfirmed();
          } else {
            component.showGroupChange.emit(0);
          }
        }, (error) => {
          this.buttonsEnabled = true;
          this.closePopUp();
        }
      );
    } else {
      this.createGroupService.newGroup(this.groupDetailsModel).subscribe((response) => {
        this.buttonsEnabled = true;

        this.ngOnInit();
        if (goToVenue) {
          this.venueSwitchConfirmed();
        } else {
          component.showGroupChange.emit(response);
        }
      }, (error) => {
        this.buttonsEnabled = true;
        this.closePopUp();

      });
    }
    ;
  }

  showVenue(id) {
    this.switchVenueDestination = id;
    if (this.stateChanged()) {
      this.switchVenue = true;
    } else {
      this.venueSwitchConfirmed();
    }

  }

  closePopup() {
    this.switchVenue = false;
  }

  newVenue() {
    this.switchVenueDestination = null;
    if (this.stateChanged()) {
      this.switchVenue = true;
    } else {
      this.venueSwitchConfirmed();
    }
  }

  venueSwitchConfirmed() {
    this.switchVenue = false;
    this.showVenueChange.emit(false);
    if (this.switchVenueDestination === null) { // new venue
      this.newVenueEvent.emit(this.groupDetailsModel.id);
    } else {
      this.switchVenueEvent.emit(this.switchVenueDestination);
    }
  }

  deleteGroupButton() {
    if (!this.groupDetailsModel || this.groupDetailsModel.id === 0) {
      const toast: Toast = {
        type: 'error',
        title: 'Error',
        body: 'Can\'t delete new Group',
        showCloseButton: true,
        timeout: 5000
      };
      this.toasterService.pop(toast);
    }
    let canDelete = true;
    for (const venue of this.groupDetailsModel.venues) {
      for (const sub of venue.subsidieries) {
        if (sub.status === 'Live') {
          canDelete = false;
          console.log(sub.status);
          break;
        }
      }
      if (!canDelete) {
        break;
      }
    }
    if (!canDelete) {
      this.deleteGroupLiveInfo = true;
      this.deleteGroup = false;
    } else {
      this.buttonsEnabled = false;
      const comp = this;
      this.createGroupService.deleteGroup(this.groupDetailsModel.id)
        .subscribe(
          (r) => {
            comp.showGroupChange.emit(0);
          },
          (error) => {
            this.deleteGroup = false;
            this.buttonsEnabled = true;
          });
    }
  }

  deleteLiveInfo() {
    this.deleteGroupLiveInfo = false;
  }

  saveState() {
    this.modelState = JSON.stringify(this.groupDetailsModel);
  }

  stateChanged() {
    const newState = JSON.stringify(this.groupDetailsModel);
    if (this.modelState === newState && this.modelState.length === newState.length) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/create-group/create-group.component.ts